import styles from './index.module.scss';

interface TruncatedTextProps {
  noOfLines?: number;
  text: string;
}

const TruncatedText = ({noOfLines = 2, text}: TruncatedTextProps) => (
  <span
    className={styles.truncatedTextWrap}
    style={{lineClamp: noOfLines, WebkitLineClamp: noOfLines}}
  >
    {text}
  </span>
);
export default TruncatedText;
